import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';
import { BinaryComponent } from '../binary/binary.component';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-binary-insert',
  templateUrl: './binary-insert.component.html',
  styleUrls: ['../binary/binary.component.css', './binary-insert.component.css']
})
export class BinaryInsertComponent extends BinaryComponent {

  dropped = false;

  constructor(protected activatedRoute: ActivatedRoute, protected messageService: MessageService, protected topicService: TopicService, protected http: HttpClient) {
    super(activatedRoute, messageService, topicService, http);
  }

  setTypeSpecificsFromConfiguration() {
    super.setTypeSpecificsFromConfiguration();
    this.limitedRange = this.limitedRange.concat(this.limitedRange.map(v => v + 0.5));
    this.limitedRange.push(-0.5);
    this.limitedRange.sort((a,b) => (+a - +b));
  }

  setTypeSpecificsFromState() {
    super.setTypeSpecificsFromState();
    this.dropped = this.state.solved;
    if (this.dropped) {
      if (this.elements.indexOf(this.requestedElement) == -1) {
        this.elements.push(this.requestedElement);
      }
      this.elements.sort();
      if (this.elementType == 'number') {
        this.elements.sort((a, b) => +a - +b);
      }
    }
  }

  /** on drop, check for correct position and show corresponding message */
  drop(index: number) {
    let correct = true;
    if (index >= 0 && this.elements[index] > this.requestedElement) {
      correct = false;
    }
    else if (index < this.elements.length - 1 && this.elements[index + 1] < this.requestedElement) {
      correct = false;
    }
    if (correct) {
      this.limitedRange = this.limitedRange.filter(v => v < index).concat(this.limitedRange.filter((v) => v > index).map(v => v + 1));
      if (this.limitedRange.length > 1) {
        this.limitedRange.push(index, index + 1);
      }
      this.openCard = -1;
      this.dropped = true;
      this.elements.splice(index + 1, 0, this.requestedElement);
      this.messageService.addAlertWithTimeout(this.get("correctPosition"), "success", 10000);
      if (index <= this.openCard) {
        this.openCard++;
      }
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get("wrongPosition"), "danger", 10000);
    }
  }

  

}
